import { render, staticRenderFns } from "./GovernmentResponseCard.vue?vue&type=template&id=ea9e8868&"
import script from "./GovernmentResponseCard.vue?vue&type=script&lang=js&"
export * from "./GovernmentResponseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports